import { lazy } from 'react';

const ComponentsRoutes = [
  // Dashboards
  // {
  //   path: '/community',
  //   component: lazy(() => import('../../views/community'))
  // },
  {
    path: '/components/accordion',
    component: lazy(() => import('../../views/components/accordion'))
  },
  {
    path: '/components/alerts',
    component: lazy(() => import('../../views/components/alerts'))
  },
  {
    path: '/components/autocomplete',
    component: lazy(() => import('../../views/components/autocomplete'))
  },
  {
    path: '/components/avatar',
    component: lazy(() => import('../../views/components/avatar'))
  },
  {
    path: '/components/badgePills',
    component: lazy(() => import('../../views/components/badgePills'))
  },
  {
    path: '/components/badge',
    component: lazy(() => import('../../views/components/badge'))
  },
  {
    path: '/components/block-ui',
    component: lazy(() => import('../../views/components/block-ui'))
  },
  {
    path: '/components/breadcrumbs',
    component: lazy(() => import('../../views/components/breadcrumbs'))
  },
  {
    path: '/components/buttons',
    component: lazy(() => import('../../views/components/buttons'))
  },
  {
    path: '/components/carousel',
    component: lazy(() => import('../../views/components/carousel'))
  },
  {
    path: '/components/collapse',
    component: lazy(() => import('../../views/components/collapse'))
  },
  {
    path: '/components/divider',
    component: lazy(() => import('../../views/components/divider'))
  },
  {
    path: '/components/dropdowns',
    component: lazy(() => import('../../views/components/dropdowns'))
  },
  {
    path: '/components/listGroup',
    component: lazy(() => import('../../views/components/listGroup'))
  },
  {
    path: '/components/modal',
    component: lazy(() => import('../../views/components/modal'))
  },
  {
    path: '/components/navComponent',
    component: lazy(() => import('../../views/components/navComponent'))
  },
  {
    path: '/components/offcanvas',
    component: lazy(() => import('../../views/components/offcanvas'))
  },
  {
    path: '/components/pagination',
    component: lazy(() => import('../../views/components/pagination'))
  },
  {
    path: '/components/popovers',
    component: lazy(() => import('../../views/components/popovers'))
  },
  {
    path: '/components/progress',
    component: lazy(() => import('../../views/components/progress'))
  },
  {
    path: '/components/spinners',
    component: lazy(() => import('../../views/components/spinners'))
  },
  {
    path: '/components/tabPills',
    component: lazy(() => import('../../views/components/tabPills'))
  },
  {
    path: '/components/tabs',
    component: lazy(() => import('../../views/components/tabs'))
  },
  {
    path: '/components/timeline',
    component: lazy(() => import('../../views/components/timeline'))
  },
  {
    path: '/components/toasts',
    component: lazy(() => import('../../views/components/toasts'))
  },
  {
    path: '/components/tooltips',
    component: lazy(() => import('../../views/components/tooltips'))
  },
];

export default ComponentsRoutes;
